function init() {
    // Blog promo slider
    function adjustSliderHeight() {
        $(".slider-view .slider").each(function (index, elem) {
            let sliderMaxHt = 0;
            $(elem)
                .children(".slide")
                .each(function (idx, fc) {
                    // console.log('fc', fc);
                    var tempMaxHt = $(fc).height();
                    // console.log(tempMaxHt, 'heights');
                    sliderMaxHt = tempMaxHt > sliderMaxHt ? tempMaxHt : sliderMaxHt;
                });
            $(elem).height(sliderMaxHt);
        });
    }

    $(function () {
        adjustSliderHeight();

        $(".actions__icon-btn.prv").on("click", function () {
            const sliderView = $(this).parents(".slider-view");
            let curSlide = $(sliderView).data("cur-slide");

            let slides = $(sliderView).find(".slider .slide");
            if (curSlide > 0) {
                curSlide--;
                $(slides).each(function (i, element) {
                    $(element).removeClass("active");
                });
                slides[curSlide].classList.add("active");
                $(sliderView).data("cur-slide", curSlide);
            }
        });
        $(".actions__icon-btn.nxt").on("click", function () {
            const sliderView = $(this).parents(".slider-view");
            let curSlide = $(sliderView).data("cur-slide");

            let slides = $(sliderView).find(".slider .slide");
            if (curSlide < slides.length - 1) {
                curSlide++;
                $(slides).each(function (i, element) {
                    $(element).removeClass("active");
                });
                slides[curSlide].classList.add("active");
                $(sliderView).data("cur-slide", curSlide);
            }
        });
    });

    let windowWidth = document.body.clientWidth;

    $(window).on("resize", function () {

        if (windowWidth !== document.body.clientWidth) {
            adjustSliderHeight();
            windowWidth = document.body.clientWidth;
        }
    });

}

export { init }